import { User } from '../../common/models/user';
import { AuthToken } from '../../common/models/auth-token';
import { Settings } from 'src/app/common/models/settings';

export class SetUserData {
    static readonly type = '[Auth] Set User Data';

    constructor(public user: User) {}
}

export class SetSettingsData {
    static readonly type = '[Auth] Set Settings Data';

    constructor(public settings: Settings) {}
}

export class SetUserName {
    static readonly type = '[Auth] Set User Name';

    constructor(public name: string) {}
}

export class SetAuthTokenData {
    static readonly type = '[Auth] Set Auth Token Data';

    constructor(public token: AuthToken) {}
}

export class ClearAuthState {
    static readonly type = '[Auth] Clear Auth State';

    constructor() {}
}
